import {FiltersGamesListDefaultBox} from "./filters-games-list.default.box";

export const FiltersGamesListBox = FiltersGamesListDefaultBox;